export default __webpack_public_path__ + "static/media/Men_Sizing_Guide-Mobile.daee40b0.png";